export default "/images/cover1.jpg?de8bdad0c3b3ec556f8612c1cc9a3a5b";